import { render, staticRenderFns } from "./StockAutosuggest.vue?vue&type=template&id=13867a83"
import script from "./StockAutosuggest.vue?vue&type=script&lang=js"
export * from "./StockAutosuggest.vue?vue&type=script&lang=js"
import style0 from "./StockAutosuggest.vue?vue&type=style&index=0&id=13867a83&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports